import { KTSVG } from '_metronic/helpers'
import SurveyTab1AdditionalSections from '../../Form/Components/SurveyTab1AdditionalSections'
import useFetchSurveyDetail from '../useFetchSurveyDetail'
import useViewModel from './ProductionOrderRequest/ViewModel'

const SurveyProductionOrderRequestTab: React.FC = () => {
  const { isSurveyLoaded } = useFetchSurveyDetail()
  const {
    roleId,
    isView,
    form,
    loading,
    saving,
    downloading,
    setField,
    setFactory,
    setDocument,
    setResponsibilityOwner,
    setCustomerGrade,
    addItemRow,
    removeItemRow,
    updateItemRow,
    save,
    onDownloadPdf,
  } = useViewModel()

  if (!isSurveyLoaded || loading) {
    return (
      <div className='d-flex justify-content-center py-20'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div className='row gy-5'>
      <div className='col-12'>
        <div className='card'>
          <div className='card-footer text-center text-lg-end'>
            <button
              type='button'
              disabled={loading || downloading}
              onClick={onDownloadPdf}
              className='btn btn-sm btn-secondary fw-bold me-4'>
              <KTSVG
                path='/media/icons/duotune/files/fil017.svg'
                className='svg-icon svg-icon-1x svg-icon-primary'
              />
              พิมพ์เอกสาร
            </button>
            {!isView && (
              <button
                className='btn btn-sm btn-primary fw-bold w-sm-100'
                type='button'
                disabled={saving}
                onClick={save}>
                {saving ? 'กำลังบันทึก...' : 'บันทึก'}
              </button>
            )}
          </div>
        </div>
      </div>

      <SurveyTab1AdditionalSections
        roleId={roleId}
        isView={isView}
        value={form}
        onChange={setField}
        onFactoryChange={setFactory}
        onDocumentChange={setDocument}
        onResponsibilityChange={setResponsibilityOwner}
        onCustomerGradeChange={setCustomerGrade}
        addItemRow={addItemRow}
        removeItemRow={removeItemRow}
        updateItemRow={updateItemRow}
      />
    </div>
  )
}

export default SurveyProductionOrderRequestTab
